module.exports = __webpack_public_path__ + "img/guangyuan-beast.7bb7ee9.jpg";